module.exports = __webpack_public_path__ + "static/media/companyContactInformation.7722bdc3.png";